import { useState } from "react";
import { MathShell, ResultCard, MATH_ACCENT } from "./MathShell.jsx";
import { determinant, inverse, solveLinearSystem, round } from "./mathcore.js";

export default function Matrix() {
  const [n, setN] = useState(2);
  const [m, setM] = useState(zeros(2));
  const [b, setB] = useState(["", ""]);
  const [res, setRes] = useState(null);

  const resize = (size) => {
    setN(size);
    setM(zeros(size));
    setB(Array(size).fill(""));
    setRes(null);
  };
  const setCell = (i, j, v) => {
    const cp = m.map((r) => [...r]);
    cp[i][j] = v;
    setM(cp);
  };
  const parse = () => m.map((r) => r.map((x) => parseFloat(x) || 0));

  const doDet = () => setRes({ kind: "det", value: round(determinant(parse()), 8) });
  const doInv = () => {
    const r = inverse(parse());
    setRes(r.ok ? { kind: "inv", matrix: r.inverse } : { kind: "err", msg: r.error });
  };
  const doSolve = () => {
    const bv = b.map((x) => parseFloat(x) || 0);
    const r = solveLinearSystem(parse(), bv);
    setRes(r.ok ? { kind: "sol", x: r.solution } : { kind: "err", msg: r.error });
  };

  return (
    <MathShell title="Matrix">
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {[2, 3, 4].map((s) => (
          <button key={s} onClick={() => resize(s)} style={{ flex: 1, background: n === s ? MATH_ACCENT : "#1C1E2E", color: n === s ? "#06201C" : "#9A9DBE", border: "none", borderRadius: 10, padding: "10px 0", fontWeight: 600, cursor: "pointer" }}>
            {s}×{s}
          </button>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${n},1fr)`, gap: 6, marginBottom: 14 }}>
        {m.map((row, i) =>
          row.map((v, j) => (
            <input
              key={`${i}-${j}`}
              value={v}
              onChange={(e) => setCell(i, j, e.target.value)}
              inputMode="decimal"
              style={{ background: "#13141F", border: "1px solid #262839", borderRadius: 8, color: "#E8E9F3", fontSize: 15, padding: "10px 0", textAlign: "center" }}
            />
          ))
        )}
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        <button onClick={doDet} style={btn}>Determinant</button>
        <button onClick={doInv} style={btn}>Inverse</button>
      </div>
      <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 6 }}>Solve Ax = b — enter b:</div>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${n},1fr)`, gap: 6, marginBottom: 10 }}>
        {b.map((v, i) => (
          <input
            key={i}
            value={v}
            onChange={(e) => { const cp = [...b]; cp[i] = e.target.value; setB(cp); }}
            inputMode="decimal"
            style={{ background: "#13141F", border: "1px solid #262839", borderRadius: 8, color: "#E8E9F3", fontSize: 15, padding: "10px 0", textAlign: "center" }}
          />
        ))}
      </div>
      <button onClick={doSolve} style={{ ...btn, width: "100%" }}>Solve system</button>

      {res && (
        <ResultCard>
          {res.kind === "det" && <Big>det = {res.value}</Big>}
          {res.kind === "err" && <span style={{ color: "#F8716A" }}>{res.msg}</span>}
          {res.kind === "inv" && (
            <div>
              <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 8 }}>INVERSE</div>
              {res.matrix.map((row, i) => (
                <div key={i} style={{ fontFamily: "monospace", fontSize: 14, color: "#C8CADF" }}>
                  [ {row.map((x) => round(x, 4)).join("  ")} ]
                </div>
              ))}
            </div>
          )}
          {res.kind === "sol" && (
            <div>
              <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 8 }}>SOLUTION</div>
              {res.x.map((v, i) => (
                <Big key={i}>x{i + 1} = {v}</Big>
              ))}
            </div>
          )}
        </ResultCard>
      )}
    </MathShell>
  );
}
function Big({ children }) {
  return <div style={{ fontSize: 18, fontWeight: 700, color: MATH_ACCENT }}>{children}</div>;
}
function zeros(s) {
  return Array.from({ length: s }, () => Array(s).fill(""));
}
const btn = { flex: 1, background: MATH_ACCENT, color: "#06201C", fontWeight: 700, fontSize: 15, border: "none", borderRadius: 12, padding: "13px 0", cursor: "pointer" };

